export default __webpack_public_path__ + "static/wellnet-9a4b32d6e9d1450ff03d02e1b7d93334.png";